import { gql } from '@apollo/client'
import { EMPLOYER_FRAGMENT } from '../apollo.fragment'

export const SIGNIN_BULLHORN_RECRUITER_MUTATION = gql`
	mutation signInBullhornRecruiter($payload: String!) {
		signInBullhornCustomComponent(payload: $payload) {
			authToken {
				accessToken
				expiresIn
				refreshToken
				tokenType
			}
			notificationChannel
			employer {
				...employerFragment
			}
			entity {
				modelName
				fieldValue
				fieldName
			}
		}
	}

	${EMPLOYER_FRAGMENT}
`

export const REFRESH_TOKEN = gql`
	mutation refreshToken($refreshToken: String!) {
		refreshToken(refreshToken: $refreshToken) {
			authToken {
				accessToken
				refreshToken
				tokenType
				expiresIn
			}
		}
	}
`

export const RECRUITER_CHANGE_PASSWORD = gql`
	mutation recruiterChangePassword($password: String!, $passwordConfirmation: String!) {
		recruiterChangePassword(password: $password, passwordConfirmation: $passwordConfirmation) {
			success
		}
	}
`

export const UPDATE_EMPLOYER_PASSWORD = gql`
	mutation updateEmployerPassword($password: String) {
		updateEmployer(password: $password) {
			id
		}
	}
`

export const RECRUITER_PROFILE_CHANGE_PASSWORD = gql`
	mutation employerChangePassword($oldPassword: String!, $password: String!, $passwordConfirmation: String!) {
		employerChangePassword(oldPassword: $oldPassword, password: $password, passwordConfirmation: $passwordConfirmation) {
			success
			authToken {
				accessToken
				refreshToken
				tokenType
				expiresIn
			}
		}
	}
`

export const RECRUITER_UPDATE_PROFILE = gql`
	mutation recruiterUpdateRecruiter($id: String!, $firstName: String, $lastName: String, $email: String, $title: String) {
		recruiterUpdateRecruiter(id: $id, firstName: $firstName, lastName: $lastName, email: $email, title: $title) {
			id
		}
	}
`

export const SIGNOUT_RECRUITER_MUTATION = gql`
	mutation employerSignOutMutation {
		employerSignOut {
			success
		}
	}
`
